import React from "react";
type Props = {
  kicker?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  tone?: "dark" | "light";
};
export function SectionHeading({
  kicker,
  title,
  lead,
  tone = "light"
}: Props) {
  const isDark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-68" data-mp="3f2wvxibfstv4">
      {kicker && <p className={`text-[13px] font-extrabold uppercase tracking-[0.12em] ${isDark ? "text-brand-light" : "text-brand-dark"}`} data-id="element-69" data-mp="3k0yg66klmz86">{kicker}</p>}
      <h2 className={`mt-3 font-display text-[28px] font-black leading-[1.12] tracking-tight [text-wrap:balance] sm:text-4xl ${isDark ? "text-white" : "text-navy-950"}`} data-id="element-70" data-mp="gjgl6zpxdmp6">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[17px] leading-relaxed ${isDark ? "text-white/80" : "text-muted"}`} data-id="element-71" data-mp="6tn6vqyeeth8">{lead}</p>}
    </div>;
}